import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ACCEPTED_FILE_FORMATS, ConnectivityCatalogEntry, ConnectivityCatalogLink, ConnectivityLinkAddRequest, ContentType, MAX_FILE_SIZE } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';


@Component({
  selector: 'gdp-edit-connectivity-entry-documents',
  templateUrl: './edit-connectivity-entry-documents.component.html',
  styleUrls: ['./edit-connectivity-entry-documents.component.scss']
})
export class EditConnectivityEntryDocumentsComponent implements OnInit {

  public entry: ConnectivityCatalogEntry;
  public form: UntypedFormGroup;

  public changes: boolean = false;
  public loadingRequest: boolean = false;
  public loadingDelete: number = -1;

  constructor(
    private activeModal: NgbActiveModal,
    private connectivityService: ConnectivityService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      description: new UntypedFormControl(null),
      file: new UntypedFormControl(null, Validators.required)
    })
  }

  public onFileUpload(event) {
    const file: File = event.target.files[0];
    const nameSplitted: string[] = file.name.split('.');
    const extension = nameSplitted[nameSplitted.length - 1];
    if (this.isAllowedSize(file.size) && this.isAllowedFormat(extension)) {
      this.form.controls.file.setValue({
        file: file,
        extension: ContentType[extension]
      });
      if (!this.form.controls.name.value) {
        this.form.controls.name.setValue(file.name);
      }
    } else {
      event.target.value = "";
      const errorMessage: string = this.isAllowedFormat(extension)
        ? 'connectivity.errors.file-too-big'
        : 'connectivity.errors.file-format-unsupported';
      this.notificationService.error(errorMessage)
    }
  }

  public onAddDocument() {
    if (this.form.valid) {
      this.loadingRequest = true;
      const value = this.form.value;
      const requestValue: ConnectivityLinkAddRequest = {
        name: value.name,
        content_type: value.file.extension,
        description: value.description,
        equipment_catalog_entry_id: this.entry.id
      };
      const fd = new FormData();
      fd.append('document', value.file.file);
      fd.append('request', new Blob([JSON.stringify(requestValue, null, 2)], { type: 'application/json' }));
      this.connectivityService.addDocumentToEntry(fd).subscribe((response: ConnectivityCatalogLink) => {
        this.loadingRequest = false;
        this.changes = true;
        this.entry.links.push(response);
        this.notificationService.success('connectivity.success-messages.success-add-link');
        this.resetForm();
      }, () => {
        this.loadingRequest = false;
      });
    }
  }

  public onDeleteDocument(id: number, index: number) {
    this.loadingDelete = index;
    this.connectivityService.deleteEntryDocument(id).subscribe(() => {
      this.loadingDelete = -1;
      this.notificationService.success('connectivity.success-messages.success-delete-link');
      this.entry.links.splice(index, 1);
      this.changes = true;
    }, () => {
      this.loadingDelete = -1;
    });
  }

  private isAllowedSize(size: number): boolean {
    return size <= MAX_FILE_SIZE;
  }

  private isAllowedFormat(extension: string): boolean {
    return ACCEPTED_FILE_FORMATS.includes(extension);
  }

  private resetForm() {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      description: new UntypedFormControl(null),
      file: new UntypedFormControl(null, Validators.required)
    });
  }

  close() {
    this.activeModal.close(this.changes);
  }
}

